// Forked from https://gist.github.com/Godofbrowser/bf118322301af3fc334437c683887c5f

import axios from 'axios'
import { axiosPayload } from './index'
import { store } from 'src/store'
import { Dialog as QDialog } from 'quasar'
import ReauthorisePluginDialog from 'src/axios/dialogs/ReauthorisePluginDialog.vue'

const shouldIntercept = (error) => {
  try {
    return error.response.status === 401
  }
  catch {
    return false
  }
}

const handleTokenRefresh = async () => {
  return new Promise((resolve, reject) => {
    if (!store.getters.isLoggedIn) {
      reject('Not logged in')
      return
    }

    // Need to create a separate axios instance which doesn't include the refreshTokenInterceptor
    axios.create(axiosPayload).post('/v1/user/refresh', {
      guid: store.getters.getGuid
    })
      .then(({ data }) => {
        store.dispatch('refresh', data.payload).then(() => {
          resolve(data.payload.token)
        })
      })
      .catch((err) => {
        QDialog.create({
          component: ReauthorisePluginDialog
        })
          .onOk((token) => {
            if (token) {
              resolve(token)
            }
            else {
              reject('Invalid token')
            }
          })
          .onCancel(() => {
            reject(err)
          })
      })
  })
}

const attachTokenToRequest = (request, token) => {
  request.headers['Authorization'] = 'Bearer ' + token
}

export default (axiosClient, customOptions = {}) => {
  let isRefreshing = false
  let failedQueue = []

  const options = {
    attachTokenToRequest,
    handleTokenRefresh,
    shouldIntercept,
    ...customOptions
  }
  const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
      if (error) {
        prom.reject(error)
      }
      else {
        prom.resolve(token)
      }
    })

    failedQueue = []
  }

  const interceptor = (error) => {
    if (!options.shouldIntercept(error)) {
      return Promise.reject(error)
    }

    if (error.config._retry || error.config._queued) {
      return Promise.reject(error)
    }

    const originalRequest = error.config
    if (isRefreshing) {
      return new Promise(function (resolve, reject) {
        failedQueue.push({ resolve, reject })
      }).then(token => {
        originalRequest._queued = true
        options.attachTokenToRequest(originalRequest, token)
        return axiosClient.request(originalRequest)
      }).catch(() => {
        return Promise.reject(error) // Ignore refresh token request's "err" and return actual "error" for the original request
      })
    }

    originalRequest._retry = true
    isRefreshing = true
    return new Promise((resolve, reject) => {
      options.handleTokenRefresh.call(options.handleTokenRefresh)
        .then((token) => {
          options.attachTokenToRequest(originalRequest, token)
          processQueue(null, token)
          resolve(axiosClient.request(originalRequest))
        })
        .catch((err) => {
          processQueue(err, null)
          reject(err)
        })
        .finally(() => {
          isRefreshing = false
        })
    })
  }

  axiosClient.interceptors.response.use(undefined, interceptor)
}
